import { render } from "./vpubNumberSet.vue?vue&type=template&id=4c987f8e&scoped=true"
import script from "./vpubNumberSet.vue?vue&type=script&lang=js"
export * from "./vpubNumberSet.vue?vue&type=script&lang=js"

import "./vpubNumberSet.vue?vue&type=style&index=0&id=4c987f8e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c987f8e"]])

export default __exports__